import i18next from 'i18next';

import { LANGUAGE_KEYS } from '~constants/languages';

i18next.addResources(LANGUAGE_KEYS.CHILE, 'PaymentMethodDisabled', {
  giftCardOnlinePayments: 'Las Gift Cards solo pueden ser pagadas con métodos de pago online'
});
